import { BITKUB_MENU_BOT_GRID_DISABLES } from "src/config";
import { BITKUB_MENU_BOT_GRID_DISABLES_KEY } from "src/context/constants/bitkub";

class EnvManager {
  envs = {
    isMaintenance: "REACT_APP_IS_MAINTENANCE",
    isPhoneNoLoginAvailable: "REACT_APP_PHONE_NO_LOGIN_AVAILABLE",
    bitkubMenuBotGridDisables: "REACT_APP_BITKUB_MENU_BOT_DISABLES",
    isShowRiskFeature: "REACT_APP_SHOW_RISK_FEATURE",
  };

  isMaintenance() {
    let value = process.env[this.envs.isMaintenance];
    if (value === "true") return true;
    return false;
  }

  isPhoneNoLoginAvailable() {
    let value = process.env[this.envs.isPhoneNoLoginAvailable];
    if (value === "true") return true;
    return false;
  }

  get isBitkubBotGridDisabled() {
    return (
      process.env[this.envs.bitkubMenuBotGridDisables]?.includes(
        BITKUB_MENU_BOT_GRID_DISABLES_KEY.GRID
      ) || false
    );
  }

  get isBitkubBotDcaDisabled() {
    return (
      process.env[this.envs.bitkubMenuBotGridDisables]?.includes(
        BITKUB_MENU_BOT_GRID_DISABLES_KEY.DCA
      ) || false
    );
  }

  get isShowRiskFeature() {
    return process.env[this.envs.isShowRiskFeature] === "true" ? true : false;
  }
}

const envManager = new EnvManager();
export default envManager;
